import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.define-properties";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import CmsContent from '../../CmsContent';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import styles from './Marquee.less';
import { reduce, get } from 'lodash-es';
import useDevice from '../../../hooks/use-device';
import useBrand from '../../../hooks/use-brand';
var mapClassObjectCMS = {
  overimagerightside: 'type2body',
  overimageleftside: 'type3body',
  aboveimage: '',
  belowimage: '',
  center: 'centerText'
};
export var Marquee = function Marquee(_ref) {
  var data = _ref.data;
  var device = useDevice();
  var brand = useBrand();

  var _ref2 = data || {},
      _ref2$component = _ref2.component;

  _ref2$component = _ref2$component === void 0 ? {} : _ref2$component;
  var _ref2$component$conte = _ref2$component.content;
  _ref2$component$conte = _ref2$component$conte === void 0 ? {} : _ref2$component$conte;
  var title = _ref2$component$conte.title,
      subtitle = _ref2$component$conte.subtitle,
      icon = _ref2$component$conte.icon,
      image = _ref2$component$conte.image,
      cta1 = _ref2$component$conte.cta1,
      cta2 = _ref2$component$conte.cta2,
      metadata = _ref2$component.metadata,
      _ref2$componentTempla = _ref2.componentTemplate;
  _ref2$componentTempla = _ref2$componentTempla === void 0 ? {} : _ref2$componentTempla;
  var componentType = _ref2$componentTempla.title;

  var _reduce = reduce(metadata, function (updatedMetaData, value, metaDataProperty) {
    return _objectSpread(_objectSpread({}, updatedMetaData), {}, _defineProperty({}, metaDataProperty, get(value, 'Key') || get(value, 'key') || 'defaultColor'));
  }, {}),
      background = _reduce.background,
      textalignment = _reduce.textalignment,
      headlinefontsize = _reduce.headlinefontsize,
      headlinefontcolor = _reduce.headlinefontcolor,
      textboxlocation = _reduce.textboxlocation;

  var titleContent = /*#__PURE__*/React.createElement(CmsContent, {
    content: title
  });
  var subTitleContent = /*#__PURE__*/React.createElement(CmsContent, {
    content: subtitle
  });
  var iconContent = /*#__PURE__*/React.createElement(CmsContent, {
    content: icon
  });
  var imageBackground = /*#__PURE__*/React.createElement(CmsContent, {
    content: image
  });
  var ctaContent1 = /*#__PURE__*/React.createElement(CmsContent, {
    content: cta1
  });
  var ctaContent2 = /*#__PURE__*/React.createElement(CmsContent, {
    content: cta2
  });
  var currentTextboxlocation = device.isMobile() ? 'belowimage' : textboxlocation;
  var textWidth = !image && styles['textWidth'];
  var topMarqueeFontSize = componentType === 'Top_Marquee' && image ? 'type1' : 'type3';
  var marqueeFontSize = componentType === 'Top_Marquee' ? topMarqueeFontSize : headlinefontsize;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "overlay",
    className: getClasses({
      styles: styles,
      classes: ['overlay', background, 'top-region', 'marqueeWrapper', textWidth],
      device: device
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClasses({
      styles: styles,
      classes: [brand, 'marquee', 'c3', marqueeFontSize]
    })
  }, (currentTextboxlocation === 'belowimage' || currentTextboxlocation && currentTextboxlocation.includes('overimage')) && imageBackground, (title || subtitle) && /*#__PURE__*/React.createElement("div", {
    className: styles[mapClassObjectCMS[currentTextboxlocation]]
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles['marqueeText'], " ").concat(styles[background], " ").concat(background)
  }, /*#__PURE__*/React.createElement("div", {
    className: getClasses({
      styles: styles,
      classes: [textalignment, 'marqueeContent'],
      device: device
    })
  }, title && /*#__PURE__*/React.createElement("h2", {
    className: "".concat(styles['marquee-title'], " ").concat(styles[marqueeFontSize], " ").concat(headlinefontcolor)
  }, titleContent), subtitle && /*#__PURE__*/React.createElement("div", {
    className: getClasses({
      styles: styles,
      classes: ['marquee-subtitle', 'subTitle']
    })
  }, subTitleContent, iconContent), ctaContent1 || ctaContent2 && /*#__PURE__*/React.createElement("div", {
    className: styles['cta']
  }, ctaContent1, ctaContent2)))), currentTextboxlocation === 'aboveimage' && imageBackground));
};
Marquee.propTypes = {
  data: PropTypes.object.isRequired
};
export default Marquee;